module.exports = __webpack_public_path__ + "static/media/ic_nav_06.d0b1acdc.svg";